import { render, staticRenderFns } from "./LifeExpectancyModal.vue?vue&type=template&id=388ac046&scoped=true&"
import script from "./LifeExpectancyModal.vue?vue&type=script&lang=js&"
export * from "./LifeExpectancyModal.vue?vue&type=script&lang=js&"
import style0 from "./LifeExpectancyModal.vue?vue&type=style&index=0&id=388ac046&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388ac046",
  null
  
)

export default component.exports